import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5ffbae9e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "el-dropdown-link"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("个人信息");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("vip升级");

var _hoisted_4 = /*#__PURE__*/_createTextVNode("输出套餐");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("修改密码");

var _hoisted_6 = /*#__PURE__*/_createTextVNode("退出登录");

import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
export default {
  setup: function setup(__props) {
    var router = useRouter();
    var store = useStore();
    var squareUrl = ref('https://img0.baidu.com/it/u=2601170227,3207786263&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500');

    var logout = function logout() {
      store.dispatch('app/logout');
    };

    var userInfo = function userInfo() {
      router.push('userInfo');
    };

    var changePassword = function changePassword() {
      router.push('/userInfo/userPassword');
    };

    var vips = function vips() {
      router.push('vips');
    };

    return function (_ctx, _cache) {
      var _component_el_avatar = _resolveComponent("el-avatar");

      var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      var _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createBlock(_component_el_dropdown, null, {
        dropdown: _withCtx(function () {
          return [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_dropdown_item, {
                onClick: userInfo
              }, {
                default: _withCtx(function () {
                  return [_hoisted_2];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_dropdown_item, {
                onClick: vips
              }, {
                default: _withCtx(function () {
                  return [_hoisted_3];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_dropdown_item, {
                onClick: logout
              }, {
                default: _withCtx(function () {
                  return [_hoisted_4];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_dropdown_item, {
                onClick: changePassword
              }, {
                default: _withCtx(function () {
                  return [_hoisted_5];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_dropdown_item, {
                onClick: logout
              }, {
                default: _withCtx(function () {
                  return [_hoisted_6];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_avatar, {
            shape: "square",
            size: 40,
            src: squareUrl.value
          }, null, 8, ["src"])])];
        }),
        _: 1
      });
    };
  }
};